import React from 'react';
import { format } from 'date-fns';
import { Text, toaster } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';
import { TextInputBlur } from 'Shared/TextInputBlur';

const useStyles = createUseStyles({
  startEndDate: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
  },
});

export const START_DATE = 'start';
export const END_DATE = 'end';
/**
 * Используется компонент TextInputBlur, поэтому изменение значения будут происходить при потере фокуса.
 * @param {string} startDate любая стрингова дата, которая подходит для new Date()
 * @param {string} endDate любая стрингова дата, которая подходит для new Date()
 * @param {({ name, value }) => void} updateDate ({ name: START_DATE | END_DATE, value: string }) => void - функция изменения значения, которая вызывается при onBlur.
 *                                     * name: какая дата start или end
 *                                     * value: значение даты из инпута
 */
export const StartEndDate = React.memo(({
  startDate,
  endDate,
  updateDate,
  overriddenStartName = '',
  overriddenEndName = '',
  disabled = false,
}) => {
  const classes = useStyles();
  const INPUT_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm";
  // const maxEndDate = React.useMemo(() => format(new Date(), INPUT_DATE_FORMAT), []);

  const startDateValue = React.useMemo(() => (
    startDate ? format(new Date(startDate), INPUT_DATE_FORMAT) : ''
  ), [startDate]);
  const endDateValue = React.useMemo(() => ((
    endDate ? format(new Date(endDate), INPUT_DATE_FORMAT) : ''
  )), [endDate]);

  const onChangeDate = React.useCallback((event, setValue) => {
    const { name, value } = event.target;

    let newDateValue = value;
    if (name === START_DATE
      && endDateValue
      && (new Date(value).getTime() > new Date(endDateValue).getTime())
    ) {
      toaster.danger('Время "С" должно быть меньше "ПО"', { id: name });
      newDateValue = endDateValue;
      setValue(endDateValue);
    } else if (name === END_DATE
      && startDateValue
      && (new Date(startDateValue).getTime() > new Date(value).getTime())
    ) {
      toaster.danger('Время "ПО" должно быть больше "С"', { id: name });
      newDateValue = startDateValue;
      setValue(startDateValue);
    }

    if (updateDate) updateDate({ name, value: newDateValue });
  }, [endDateValue, startDateValue, updateDate]);

  return (
    <div className={classes.startEndDate}>
      <Text> с </Text>
      <TextInputBlur
        width="auto"
        type="datetime-local"
        name={overriddenStartName || 'start'}
        value={startDateValue}
        // onChange={onChangeDate}
        updateValue={onChangeDate}
        max={endDateValue}
        disabled={disabled}
      />
      <Text> по </Text>
      <TextInputBlur
        width="auto"
        type="datetime-local"
        name={overriddenEndName || 'end'}
        value={endDateValue}
        // onChange={onChangeDate}
        updateValue={onChangeDate}
        min={startDateValue}
        // max={maxEndDate}
        disabled={disabled}
      />
    </div>
  );
});
StartEndDate.displayName = 'StartEndDate';
